/* eslint-disable jsx-a11y/alt-text */

import React, { useContext } from 'react';
import AppMenuItem from './AppMenuitem'; // Ensure AppMenuItem is updated for React Router
import { LayoutContext } from './context/LayoutContext';
import { MenuProvider } from './context/menucontext';
import { NavLink } from 'react-router-dom'; // Replacing Next.js Link
import { AppMenuItem as MenuItemType } from '../types/types';

const AppMenu: React.FC = () => {
    const { layoutConfig } = useContext(LayoutContext);

    // Retrieve and parse roleRouteMappings from localStorage
    const roleRouteMappings = localStorage.getItem('roleRouteMappings');
    let model: MenuItemType[] = [];

    try {
        // Parse roleRouteMappings and ensure it's an array
        model = roleRouteMappings ? JSON.parse(roleRouteMappings) : [];
        if (!Array.isArray(model)) {
            console.error('roleRouteMappings is not an array');
            model = [];
        }
    } catch (error) {
        console.error('Error parsing roleRouteMappings:', error);
    }

    return (
        <MenuProvider>
            <ul className="layout-menu">
                {model.map((item, i) => {
                    return !item?.seperator ? (
                        <AppMenuItem item={item} root={true} index={i} key={item.label} />
                    ) : (
                        <li className="menu-separator" key={`separator-${i}`}></li>
                    );
                })}
            </ul>
        </MenuProvider>
    );
};


export default AppMenu;
